<script setup lang="ts">
import { CellState } from '@ui/components/calendar/picker'
import CalendarDay from '@ui/components/calendar/picker/day/CalendarDay.vue'
import CalendarHeaderWeekday from '@ui/components/calendar/picker/day/CalendarHeaderWeekday.vue'
import { getWeekdayName } from '@ui/utils/times'
import { isSameDay } from 'date-fns'
import { getCalendarWeek } from './calendarWeek'

const props = withDefaults(
  defineProps<{
    today?: Date
    disabledDate?: (date: Date) => boolean
    disabled?: boolean
    highlightSelected?: boolean
  }>(),
  {
    today: () => new Date(),
    highlightSelected: true,
  },
)

const emit = defineEmits<{ select: [day: Date] }>()
const model = defineModel<Date>({ default: () => new Date() })
const days = computed(() => getCalendarWeek(model.value))

function isDisabled(day: Date) {
  return props.disabled || Boolean(props.disabledDate?.(day))
}

function selectDay(day: Date) {
  if (!isDisabled(day)) {
    model.value = day
    emit('select', day)
  }
}
</script>

<template lang="pug">
.flex.row-6
  .flex.col-0.flex-1.min-w-0(v-for="day of days" :key="day.getTime()")
    CalendarHeaderWeekday(
      class="w-100p"
      :label="getWeekdayName(day)"
      :today="isSameDay(today, day)"
      :disabled="isDisabled(day)"
    )
    CalendarDay(
      class="w-100p"
      :label="String(day.getDate()).padStart(2, '0')"
      :state="isDisabled(day) ? CellState.Disabled : isSameDay(model, day) && (highlightSelected || !isSameDay(today, day)) ? CellState.Selected : CellState.Default"
      :today="isSameDay(today, day)"
      @click="selectDay(day)"
    )
</template>
